var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('AnimateWhenVisible',{attrs:{"name":"fadeUp"}},[_c('div',{staticClass:"caption"},[_c('h2',[_vm._v(_vm._s(_vm.title))]),_c('div',{staticClass:"wrapper"},[_c('div',{staticClass:"text-wrapper"},[_vm._v(_vm._s(_vm.description))])])])])}
var staticRenderFns = []

export { render, staticRenderFns }